var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumCustomUmbrella = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.901 16.472c.017 0 1.475-.694 2.813-.694 1 0 2.186.948 2.542 1.32l.542.542.542-.542c.373-.372 1.56-1.32 2.56-1.32.846 0 1.812.677 2.32 1.117v8.987a2.323 2.323 0 0 0 2.322 2.318 2.323 2.323 0 0 0 2.321-2.318v-1.54h-1.542v1.54a.788.788 0 0 1-.779.778.788.788 0 0 1-.78-.778v-8.987c.509-.44 1.475-1.117 2.322-1.117 1 0 2.186.948 2.542 1.32l.542.542.542-.542c.373-.372 1.56-1.32 2.559-1.32 1.338 0 2.796.694 2.813.694l1.118.542v-1.236c0-6.972-5.49-12.049-12.437-12.404V1.8h-1.526v1.574C7.29 3.729 1.8 8.806 1.8 15.778v1.236l1.101-.542z",
    fill: "#1B7690",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumCustomUmbrella);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-custom-umbrella.bbaff4b0145ee113c95856fb75b6379d.svg";